import React, { useState } from 'react';
import { X, Check } from 'lucide-react';
import { Button } from './ui/button';
import UpgradeToSmartModal from './UpgradeToSmartModal';
import { useLanguage } from '../context/LanguageContext';

const ComparisonSection = () => {
  const { t } = useLanguage();
  const [modalOpen, setModalOpen] = useState(false);
  const traditionalFeatures = t('cmp.trad');
  const rentkollectFeatures = t('cmp.smart');

  return (
    <section className="py-16 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">{t('cmp.h2')}</h2>
          <p className="text-2xl font-semibold text-blue-600">{t('cmp.sub')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Traditional */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-red-200">
            <div className="text-center mb-6">
              <div className="inline-block bg-red-100 rounded-full p-4 mb-4">
                <X className="text-red-600" size={48} />
              </div>
              <h3 className="text-2xl font-bold text-red-600">{t('cmp.trad_title')}</h3>
              <p className="text-gray-600">{t('cmp.trad_sub')}</p>
            </div>
            <ul className="space-y-3">
              {traditionalFeatures.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <X className="text-red-500 flex-shrink-0 mt-1" size={20} />
                  <span className="text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Smart */}
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 shadow-xl text-white border-2 border-blue-400 relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-yellow-400 text-gray-900 px-6 py-2 rounded-bl-2xl font-bold">
              {t('cmp.recommended')}
            </div>
            <div className="text-center mb-6 mt-8">
              <div className="inline-block bg-green-100 rounded-full p-4 mb-4">
                <Check className="text-green-600" size={48} />
              </div>
              <h3 className="text-2xl font-bold">{t('cmp.smart_title')}</h3>
              <p className="text-blue-100">{t('cmp.smart_sub')}</p>
            </div>
            <ul className="space-y-3">
              {rentkollectFeatures.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <Check className="text-green-400 flex-shrink-0 mt-1" size={20} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 text-center">
              <Button
                data-testid="upgrade-to-smart-btn"
                onClick={() => setModalOpen(true)}
                className="bg-white text-blue-600 hover:bg-gray-100 rounded-lg px-8 py-6 text-lg font-bold w-full"
              >
                {t('cmp.cta')}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <UpgradeToSmartModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </section>
  );
};

export default ComparisonSection;
